<app-dialog
  [title]="title"
  [actions]="actions"
  (action)="action($event)"
  (close)="close()"
> 
<div class="form" [formGroup]="form">
    <div class="input-container">
        <label for="" class="input-container_label">Date</label>
        <input type="text" [min]="minDate" class="input-container_input" formControlName="eventDate" [matDatepicker]="picker">
        
        <div class="input-container_trigger"><mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle></div>
        <mat-datepicker #picker ></mat-datepicker>
    </div>

    <div class="input-container">
        <label for="" class="input-container_label">Additional sales amount</label>
        <input type="number" class="input-container_input"  formControlName="amount">
    </div>

    <div class="input-container">
        <label for="" class="input-container_label">Description</label>
        <input type="text" class="input-container_input" placeholder="Write your description" formControlName="description">
    </div>
</div>
 
</app-dialog>